import PropTypes from 'prop-types'

const Icon = ({ type, className = '' }) => {
  switch (type) {
    case 'arrow-down':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 15.375L6 9.37501L7.4 7.97501L12 12.575L16.6 7.97501L18 9.37501L12 15.375Z"
            fill="#212121"
          />
        </svg>
      )
    case 'cross':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
            fill="white"
          />
        </svg>
      )
    case 'magnifying-glass':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.146 15.371 4.888 14.113C3.62933 12.8543 3 11.3167 3 9.5C3 7.68333 3.62933 6.14567 4.888 4.887C6.146 3.629 7.68333 3 9.5 3C11.3167 3 12.8543 3.629 14.113 4.887C15.371 6.14567 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8127 13.5627 12.688 12.688C13.5627 11.8127 14 10.75 14 9.5C14 8.25 13.5627 7.18733 12.688 6.312C11.8127 5.43733 10.75 5 9.5 5C8.25 5 7.18733 5.43733 6.312 6.312C5.43733 7.18733 5 8.25 5 9.5C5 10.75 5.43733 11.8127 6.312 12.688C7.18733 13.5627 8.25 14 9.5 14Z"
            fill="white"
          />
        </svg>
      )
    case 'tick':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.54998 18L3.84998 12.3L5.27498 10.875L9.54998 15.15L18.725 5.97501L20.15 7.40001L9.54998 18Z"
            fill="#ffffff"
          />
        </svg>
      )
    case 'sync':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 4H20V6H17.25L17.65 6.35C18.4667 7.16667 19.0627 8.054 19.438 9.012C19.8127 9.97067 20 10.95 20 11.95C20 13.8 19.4457 15.4457 18.337 16.887C17.229 18.329 15.7833 19.2833 14 19.75V17.65C15.2 17.2167 16.1667 16.4793 16.9 15.438C17.6333 14.396 18 13.2333 18 11.95C18 11.2 17.8583 10.4707 17.575 9.762C17.2917 9.054 16.85 8.4 16.25 7.8L16 7.55V10H14V4ZM10 20H4V18H6.75L6.35 17.65C5.48333 16.8833 4.875 16.0083 4.525 15.025C4.175 14.0417 4 13.05 4 12.05C4 10.2 4.554 8.554 5.662 7.112C6.77067 5.67067 8.21667 4.71667 10 4.25V6.35C8.8 6.78333 7.83333 7.52067 7.1 8.562C6.36667 9.604 6 10.7667 6 12.05C6 12.8 6.14167 13.529 6.425 14.237C6.70833 14.9457 7.15 15.6 7.75 16.2L8 16.45V14H10V20Z"
            fill="#ffffff"
          />
        </svg>
      )
    case 'print':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 8V5H8V8H6V3H18V8H16ZM18 12.5C18.2833 12.5 18.5207 12.404 18.712 12.212C18.904 12.0207 19 11.7833 19 11.5C19 11.2167 18.904 10.979 18.712 10.787C18.5207 10.5957 18.2833 10.5 18 10.5C17.7167 10.5 17.4793 10.5957 17.288 10.787C17.096 10.979 17 11.2167 17 11.5C17 11.7833 17.096 12.0207 17.288 12.212C17.4793 12.404 17.7167 12.5 18 12.5ZM16 19V15H8V19H16ZM18 21H6V17H2V8H22V17H18V21ZM20 15V10H4V15H6V13H18V15H20ZM4 10H20H6H4Z"
            fill="#212121"
          />
        </svg>
      )
    case 'compass':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          title="compass"
        >
          <path
            d="M6.5 17.5L14 14L17.5 6.5L10 10L6.5 17.5ZM12 13C11.7167 13 11.4793 12.904 11.288 12.712C11.096 12.5207 11 12.2833 11 12C11 11.7167 11.096 11.479 11.288 11.287C11.4793 11.0957 11.7167 11 12 11C12.2833 11 12.521 11.0957 12.713 11.287C12.9043 11.479 13 11.7167 13 12C13 12.2833 12.9043 12.5207 12.713 12.712C12.521 12.904 12.2833 13 12 13ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
            fill="#212121"
          />
        </svg>
      )
    case 'palette':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          title="palette"
        >
          <path
            d="M12 22C10.6333 22 9.34167 21.7373 8.125 21.212C6.90833 20.6873 5.846 19.9707 4.938 19.062C4.02933 18.154 3.31267 17.0917 2.788 15.875C2.26267 14.6583 2 13.3667 2 12C2 10.6167 2.27067 9.31667 2.812 8.1C3.354 6.88333 4.08767 5.825 5.013 4.925C5.93767 4.025 7.01667 3.31233 8.25 2.787C9.48333 2.26233 10.8 2 12.2 2C13.5333 2 14.7917 2.22933 15.975 2.688C17.1583 3.146 18.1957 3.77933 19.087 4.588C19.979 5.396 20.6873 6.35433 21.212 7.463C21.7373 8.571 22 9.76667 22 11.05C22 12.9667 21.4167 14.4373 20.25 15.462C19.0833 16.4873 17.6667 17 16 17H14.15C14 17 13.896 17.0417 13.838 17.125C13.7793 17.2083 13.75 17.3 13.75 17.4C13.75 17.6 13.875 17.8873 14.125 18.262C14.375 18.6373 14.5 19.0667 14.5 19.55C14.5 20.3833 14.2707 21 13.812 21.4C13.354 21.8 12.75 22 12 22ZM6.5 13C6.93333 13 7.29167 12.8583 7.575 12.575C7.85833 12.2917 8 11.9333 8 11.5C8 11.0667 7.85833 10.7083 7.575 10.425C7.29167 10.1417 6.93333 10 6.5 10C6.06667 10 5.70833 10.1417 5.425 10.425C5.14167 10.7083 5 11.0667 5 11.5C5 11.9333 5.14167 12.2917 5.425 12.575C5.70833 12.8583 6.06667 13 6.5 13ZM9.5 9C9.93333 9 10.2917 8.85833 10.575 8.575C10.8583 8.29167 11 7.93333 11 7.5C11 7.06667 10.8583 6.70833 10.575 6.425C10.2917 6.14167 9.93333 6 9.5 6C9.06667 6 8.70833 6.14167 8.425 6.425C8.14167 6.70833 8 7.06667 8 7.5C8 7.93333 8.14167 8.29167 8.425 8.575C8.70833 8.85833 9.06667 9 9.5 9ZM14.5 9C14.9333 9 15.2917 8.85833 15.575 8.575C15.8583 8.29167 16 7.93333 16 7.5C16 7.06667 15.8583 6.70833 15.575 6.425C15.2917 6.14167 14.9333 6 14.5 6C14.0667 6 13.7083 6.14167 13.425 6.425C13.1417 6.70833 13 7.06667 13 7.5C13 7.93333 13.1417 8.29167 13.425 8.575C13.7083 8.85833 14.0667 9 14.5 9ZM17.5 13C17.9333 13 18.2917 12.8583 18.575 12.575C18.8583 12.2917 19 11.9333 19 11.5C19 11.0667 18.8583 10.7083 18.575 10.425C18.2917 10.1417 17.9333 10 17.5 10C17.0667 10 16.7083 10.1417 16.425 10.425C16.1417 10.7083 16 11.0667 16 11.5C16 11.9333 16.1417 12.2917 16.425 12.575C16.7083 12.8583 17.0667 13 17.5 13ZM12 20C12.15 20 12.271 19.9583 12.363 19.875C12.4543 19.7917 12.5 19.6833 12.5 19.55C12.5 19.3167 12.375 19.0417 12.125 18.725C11.875 18.4083 11.75 17.9333 11.75 17.3C11.75 16.6 11.9917 16.0417 12.475 15.625C12.9583 15.2083 13.55 15 14.25 15H16C17.1 15 18.0417 14.679 18.825 14.037C19.6083 13.3957 20 12.4 20 11.05C20 9.03333 19.2293 7.354 17.688 6.012C16.146 4.67067 14.3167 4 12.2 4C9.93333 4 8 4.775 6.4 6.325C4.8 7.875 4 9.76667 4 12C4 14.2167 4.77933 16.1043 6.338 17.663C7.896 19.221 9.78333 20 12 20Z"
            fill="#212121"
          />
        </svg>
      )
    case 'rocket':
      return (
        <svg
          className={className}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          title="rocket"
        >
          <path
            d="M5.64999 10.025L7.59999 10.85C7.83332 10.3833 8.07499 9.93332 8.32499 9.49998C8.57499 9.06665 8.84999 8.63332 9.14999 8.19998L7.74999 7.92498L5.64999 10.025ZM9.19999 12.1L12.05 14.925C12.75 14.6583 13.5 14.25 14.3 13.7C15.1 13.15 15.85 12.525 16.55 11.825C17.7167 10.6583 18.6293 9.36265 19.288 7.93798C19.946 6.51265 20.2333 5.19998 20.15 3.99998C18.95 3.91665 17.6333 4.20398 16.2 4.86198C14.7667 5.52065 13.4667 6.43332 12.3 7.59998C11.6 8.29998 10.975 9.04998 10.425 9.84998C9.87499 10.65 9.46665 11.4 9.19999 12.1ZM13.65 10.475C13.2667 10.0917 13.075 9.62065 13.075 9.06198C13.075 8.50398 13.2667 8.03332 13.65 7.64998C14.0333 7.26665 14.5083 7.07498 15.075 7.07498C15.6417 7.07498 16.1167 7.26665 16.5 7.64998C16.8833 8.03332 17.075 8.50398 17.075 9.06198C17.075 9.62065 16.8833 10.0917 16.5 10.475C16.1167 10.8583 15.6417 11.05 15.075 11.05C14.5083 11.05 14.0333 10.8583 13.65 10.475ZM14.125 18.5L16.225 16.4L15.95 15C15.5167 15.3 15.0833 15.5707 14.65 15.812C14.2167 16.054 13.7667 16.2916 13.3 16.525L14.125 18.5ZM21.95 2.17498C22.2667 4.19165 22.071 6.15398 21.363 8.06198C20.6543 9.97065 19.4333 11.7916 17.7 13.525L18.2 16C18.2667 16.3333 18.25 16.6583 18.15 16.975C18.05 17.2917 17.8833 17.5666 17.65 17.8L13.45 22L11.35 17.075L7.07499 12.8L2.14999 10.7L6.32499 6.49998C6.55832 6.26665 6.83765 6.09998 7.16299 5.99998C7.48765 5.89998 7.81665 5.88332 8.14999 5.94998L10.625 6.44998C12.3583 4.71665 14.175 3.49165 16.075 2.77498C17.975 2.05832 19.9333 1.85832 21.95 2.17498ZM3.92499 15.975C4.50832 15.3917 5.22065 15.0957 6.06199 15.087C6.90399 15.079 7.61665 15.3667 8.19999 15.95C8.78332 16.5333 9.07065 17.2456 9.06199 18.087C9.05399 18.929 8.75832 19.6416 8.17499 20.225C7.75832 20.6416 7.06265 21 6.08799 21.3C5.11265 21.6 3.76665 21.8666 2.04999 22.1C2.28332 20.3833 2.54999 19.0373 2.84999 18.062C3.14999 17.0873 3.50832 16.3917 3.92499 15.975ZM5.34999 17.375C5.18332 17.5417 5.01665 17.846 4.84999 18.288C4.68332 18.7293 4.56665 19.175 4.49999 19.625C4.94999 19.5583 5.39599 19.446 5.83799 19.288C6.27932 19.1293 6.58332 18.9666 6.74999 18.8C6.94999 18.6 7.05832 18.3583 7.07499 18.075C7.09165 17.7916 6.99999 17.55 6.79999 17.35C6.59999 17.15 6.35832 17.054 6.07499 17.062C5.79165 17.0707 5.54999 17.175 5.34999 17.375Z"
            fill="#212121"
          />
        </svg>
      )
    case 'chevron-right':
      return (
        <svg
          className={className}
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.6667 30L13.3333 27.6667L21 20L13.3333 12.3333L15.6667 10L25.6667 20L15.6667 30Z"
            fill="#212121"
          />
        </svg>
      )
    case 'copy':
      return (
        <svg
          className={className}
          width="17"
          height="20"
          viewBox="0 0 17 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 16C5.45 16 4.97933 15.8043 4.588 15.413C4.196 15.021 4 14.55 4 14V2C4 1.45 4.196 0.979 4.588 0.587C4.97933 0.195667 5.45 0 6 0H15C15.55 0 16.021 0.195667 16.413 0.587C16.8043 0.979 17 1.45 17 2V14C17 14.55 16.8043 15.021 16.413 15.413C16.021 15.8043 15.55 16 15 16H6ZM6 14H15V2H6V14ZM2 20C1.45 20 0.979 19.8043 0.587 19.413C0.195667 19.021 0 18.55 0 18V4H2V18H13V20H2ZM6 2V14V2Z"
            fill="white"
          />
        </svg>
      )
    case 'external-link':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M5 3.5C3.90694 3.5 3 4.40694 3 5.5V19.5C3 20.5931 3.90694 21.5 5 21.5H19C20.0931 21.5 21 20.5931 21 19.5V12.5H19V19.5H5V5.5H12V3.5H5ZM14 3.5V5.5H17.5859L8.29297 14.793L9.70703 16.207L19 6.91406V10.5H21V3.5H14Z"
            fill="white"
          />
        </svg>
      )
    default:
      return null
  }
}

Icon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
}

export default Icon
